module.exports = __webpack_public_path__ + "images/feature/20171110-2-5d8e631bc2228118cf1518574144d9d1.png";